module.exports = new Promise(function (resolve, reject) {
    if (window['coreWeb']) {
      resolve(window['coreWeb']);
      return;
    }

    var appEnv = (window.__env__ && window.__env__['overtimeWeb']) || {};
    var host = appEnv['CORE_WEB_HOST'] || "";

    if (!host) {
      reject(new Error('Missing remote host: CORE_WEB_HOST'));
      return;
    }

    var src = host.replace(/\/$/, '') + '/remoteEntry.js';
    var existingScript = document.querySelector('script[data-webpack-runtime-remote="coreWeb"]');

    if (existingScript) {
      existingScript.addEventListener('load', function () {
        resolve(window['coreWeb']);
      });
      existingScript.addEventListener('error', function () {
        reject(new Error('Failed to load coreWeb'));
      });
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.dataset.webpackRuntimeRemote = 'coreWeb';
    script.onload = function () {
      resolve(window['coreWeb']);
    };
    script.onerror = function () {
      reject(new Error('Failed to load coreWeb'));
    };
    document.head.appendChild(script);
  });